export const fillVariables = (template, variables) => {
  // template should be a url:
  // - url got from backend by route name
  // - url got from "php artisan route:list" (with usage of {variables}) e.g. venue-cabinet/venue/{id}/location
  if (!template) {
    throw new Error(`Couldn't fill route variable for template: ${template}`);
  }

  if (!variables || typeof variables !== 'object') {
    throw new Error('Variables must be an object');
  }

  let filled = template;
  Object.keys(variables).forEach((key) => {
    filled = filled.split(`-${key}-`).join(variables[key]);
    filled = filled.split(`{${key}}`).join(variables[key]);
  });

  return filled;
};
